import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ViewSwitcher from 'ps-components/ViewSwitcher/ViewSwitcher';

const tabList = ['Top 5 Surveys', 'Bottom 5 Surveys'];
class SurveyUtilizationTabs extends Component {
  static propTypes = {
    surveyTabChange: PropTypes.func
  };
  constructor(props) {
    super(props);

    this.state = {
      showTopSurveys: 0
    };
    this.tabClick = this.tabClick.bind(this);
  }
  tabClick() {
    this.props.surveyTabChange.apply(this);
    this.setState({
      showTopSurveys: this.state.showTopSurveys === 0 ? 1 : 0
    });
  }

  render() {
    return (
      <div className="db-survey__tabs">
        <ViewSwitcher
          className="survey__switcher"
          isSticky={false}
          tabList={tabList}
          activeTab={this.state.showTopSurveys}
          tabSwitch={this.tabClick}
        />
      </div>
    );
  }
}

export default SurveyUtilizationTabs;
